<template>
  <div id="grid-proveedor">
    <v-container grid-list-xl fluid>
      <template>
        <v-layout justify-center>
          <v-flex lg12>
            <v-data-table
              :headers="headers"
              :items="itemsAuditoria"
              :rows-per-page-items="rowsTable"
              class="elevation-1"
            >
              <template v-slot:items="props">
                <td class="text-xs-left">{{ props.item.accion }}</td>
                <td class="text-xs-left">{{ props.item.username }}</td>
                <td class="text-xs-left">{{ props.item.proceso }}</td>
                <td class="text-xs-left">{{ props.item.claseImpactada }}</td>
                <td class="text-xs-left">{{ props.item.fechaCreacion }}</td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </template>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "grid-proveedor",
  components: {},
  props: {
    itemsAuditoria: Array,
    rowsTable: String,
    processIcon: String,
    visitIcon: String,
    relojIcon: String,
    editIcon: String,
    deleteIcon: String,
    detailIcon: String,
  },
  data() {
    return {
      userlogged: "",
      userloggedr: "",
      btnEdit: false,
      dialogDelete: false,
      dialogEdit: false,
      dialogDetail: false,
      headers: [
        { text: "Accion", align: "left", sortable: false, value: "accion" },
        { text: "Usuario", align: "left", sortable: false, value: "usuario" },
        { text: "Proceso", align: "left", sortable: false, value: "proceso" },
        { text: "Entidad", align: "left", sortable: false, value: "entidad" },
        { text: "Fecha", align: "left", sortable: false, value: "fecha" },
      ],
      unProveedor: [],
      id: Number,
      tipoModal: "",
      userId: "",
      btnHidden: false,
    };
  },
  mounted: function () {
    this.userId = this.$store.getters.userLogged.id;
  },
  created() {
    console.log("user logged", this.$store.getters.userLogged);
    this.userLogged = this.$store.getters.userLogged.id;
  },
  computed: {},
  methods: {},
};
</script>
